(()=>{'use strict';
const KEY='vb-wishlist-v2';
const read=()=>{try{const a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a:[]}catch(e){return[]}};
const paint=bump=>{
  const n=read().length;
  document.querySelectorAll('[data-wishlist-count]').forEach(b=>{
    b.textContent=n>99?'99+':String(n);b.hidden=n===0;
    if(bump&&n){b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump')}
  });
  document.querySelectorAll('.header-wish').forEach(a=>{
    a.classList.toggle('has-items',n>0);
    a.setAttribute('aria-label',n?`View wishlist, ${n} saved`:'View wishlist');
  });
  document.querySelectorAll('[data-wishlist-clear]').forEach(b=>{if(b.parentElement)b.parentElement.hidden=n===0});
};
paint(false);
document.addEventListener('click',e=>{
  if(e.target.closest('[data-wishlist]')||e.target.closest('.wishlist-result>button'))setTimeout(()=>paint(true),0);
});
addEventListener('storage',e=>{if(e.key===KEY)paint(false)});
addEventListener('pageshow',()=>paint(false));

document.querySelectorAll('[data-wishlist-clear]').forEach(b=>b.addEventListener('click',()=>{
  if(!confirm('Remove all saved products from this browser?'))return;
  try{localStorage.removeItem(KEY)}catch(e){}
  location.reload();
}));

/* open details that hold a message or an error */
document.querySelectorAll('details.vba-auto').forEach(d=>{
  if(d.querySelector('.vba-errors,.vba-ok')||(d.id&&location.hash==='#'+d.id))d.open=true;
});

/* delete saved address */
document.querySelectorAll('[data-address-delete]').forEach(b=>b.addEventListener('click',()=>{
  if(!confirm('Delete this address?'))return;
  if(window.Shopify&&Shopify.postLink)Shopify.postLink(b.dataset.addressDelete,{parameters:{_method:'delete'}});
}));
})();

/* Profile / Orders tabs (deep-link with /account#orders) */
(()=>{
  const tabs=document.querySelectorAll('[data-vba-tab]'),panels=document.querySelectorAll('[data-vba-panel]');
  if(!panels.length)return;
  const show=(name,push)=>{
    if(![...panels].some(p=>p.dataset.vbaPanel===name))name='profile';
    panels.forEach(p=>p.classList.toggle('is-on',p.dataset.vbaPanel===name));
    document.querySelectorAll('.vba-tab[data-vba-tab]').forEach(t=>t.classList.toggle('is-on',t.dataset.vbaTab===name));
    if(push){try{history.replaceState(null,'','#'+name)}catch(e){}}
  };
  const initial=()=>{
    const h=location.hash.replace('#','');
    if(h==='orders'||h==='profile')return h;
    return /[?&]page=/.test(location.search)?'orders':'profile';
  };
  show(initial(),false);
  tabs.forEach(t=>t.addEventListener('click',e=>{e.preventDefault();show(t.dataset.vbaTab,true);const top=document.querySelector('.vba-layout');if(top)top.scrollIntoView({behavior:'smooth',block:'start'})}));
  addEventListener('hashchange',()=>show(initial(),false));
})();
